import { ORDER } from "./constants";

const ORDER_TYPE_ALIASES: Record<string, string[]> = {
  [ORDER.TAKE_OUT]: [
    "takeout",
    "take out",
    "pickup",
    "pick up",
    "to go",
    "togo",
    "to stay",
    "tostay",
    "dinein",
    "dine in",
  ],
  [ORDER.DELIVERY]: ["delivery", "deliver"],
};

const normalizeOrderTypeToken = (value: any) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

export const getProductOrderTypeAvailability = (
  product: any,
  orderType: string
) => {
  const restrictionSource =
    Number(product?.disableonordertype || 0) === 1 || product?.disableordtype
      ? product
      : Number(product?.data?.disableonordertype || 0) === 1 ||
        product?.data?.disableordtype
      ? product.data
      : product?.data?.product || product?.product || {};

  const disableOnOrderType =
    Number(restrictionSource?.disableonordertype || 0) === 1;
  const disabledOrderTypeText = String(
    restrictionSource?.disableordtype || ""
  ).trim();

  if (!disableOnOrderType || !disabledOrderTypeText) {
    return { unavailable: false, reason: "" };
  }

  const normalizedOrderType = normalizeOrderTypeToken(orderType);
  const aliases = [
    normalizedOrderType,
    ...(ORDER_TYPE_ALIASES[orderType] || []),
  ].filter(Boolean);

  const disabledTypes = disabledOrderTypeText
    .split("|")
    .map(normalizeOrderTypeToken)
    .filter(Boolean);

  const unavailable = disabledTypes.some((disabledType) =>
    aliases.includes(disabledType)
  );
  const label = orderType === ORDER.DELIVERY ? "Delivery" : "Pickup";

  return {
    unavailable,
    reason: unavailable ? `Not available for ${label}` : "",
  };
};

export const isProductAvailableForOrderType = (
  product: any,
  orderType: string
) => !getProductOrderTypeAvailability(product, orderType).unavailable;

export const getUnavailableCartItemsForOrderType = (
  cart: any[] = [],
  orderType: string
) =>
  cart
    .map((item, index) => ({
      item,
      index,
      ...getProductOrderTypeAvailability(item, orderType),
    }))
    .filter((entry) => entry.unavailable);
